export const AnalyticsCard = ({
  title,
  value,
  className = "",
}: {
  title: string;
  value: string;
  className?: string;
}) => {
  return (
    <div
      className={`p-4 sm:p-5 lg:p-6 xl:p-3 xl:py-2 2xl:p-5 rounded-lg bg-surface-tertiary border border-border-primary transition-all duration-300 ease-in-out text-center ${className}`}
    >
      <div className="text-stone-900 text-sm sm:text-base font-medium leading-tight">
        {title}
      </div>
      <div className="text-stone-950 text-base sm:text-lg font-bold leading-tight">
        {value}
      </div>
    </div>
  );
};
